import React from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import AsyncSelect from 'react-select/async';
import { getPicklist } from '../actions';
import { countryList } from '../../../../utils/constants';

const exceptionRoom = ['HDB 1 room', 'HDB 2 room', 'HDB 3 room', 'HDB 4 room', 'HDB 5 room','1 room','2 room','3 room','4 room','5 room']
class Address extends React.Component {
    shouldComponentUpdate() {
        return true;
    }

    render() {
        const { props } = this;
        return (
            <div className="row">
                <br />
                <h4 className="info-text">Address</h4>
                <br />
                <div className="col-sm-6">
                    <div className="form-group">
                        <label>Postal Code <small className="red">(required)</small></label>               
                        <AsyncSelect
                            placeholder="Postal Code"
                            name="Postal__c"
                            cacheOptions
                            isClearable
                            className={`basic-single valid select ${props.errorMessage.Postal__c ? 'need-fix' : ''}`}
                            id="Postal__c"
                            loadOptions={props.getPostaCodeOptions}
                            value={{ value: props.form.Postal__c, label: props.form.Postal__c }}
                            defaultOptions
                            onChange={val => props.onInputChanged(val, 'Postal__c')}
                        />
                        <p className="error-message">{props.errorMessage.Postal__c}</p>
                    </div>
                    <div className="form-group">
                        <label>Street Name <small className="red">(required)</small></label>
                        <input
                            id="Street__c"
                            name="Street__c"
                            type="text"
                            className={`form-control valid select ${props.errorMessage.Street__c ? 'need-fix' : ''}`}
                            value={props.form.Street__c || ''}
                            onChange={props.onInputChanged}
                        />
                        <p className="error-message">{props.errorMessage.Street__c}</p>
                    </div>
                    <div className="form-group">
                        <label>Block Number <small className="red">(required)</small></label>
                        <input
                            id="Block__c"
                            name="Block__c"
                            type="text"
                            className={`form-control valid select ${props.errorMessage.Block__c ? 'need-fix' : ''}`}
                            placeholder="Put NA if not applicable"
                            value={props.form.Block__c || ''}
                            onChange={props.onInputChanged}
                        />
                        <p className="error-message">{props.errorMessage.Block__c}</p>
                    </div>
                   
                </div>
                <div className="col-sm-6">
                    <div className="form-group">
                        <label>Type of Flat <small className="red">(required)</small></label>
                        <select
                            id="Flat_Type__c"
                            name="Flat_Type__c"
                            aria-invalid="false"
                            className={`form-control valid select ${props.errorMessage.Flat_Type__c ? 'need-fix' : ''}`}
                            value={props.form.Flat_Type__c || ''}
                            onChange={props.onInputChanged}
                        >
                            <option value="" />
                            {getPicklist('Flat_Type__c', props.objectInfo.Application__c, "component", exceptionRoom)}
                        </select>
                        <p className="error-message">{props.errorMessage.Flat_Type__c}</p>
                    </div>
                    <div className="form-group">
                        <label>Specify Other HDB Flat Types</label>
                        <input
                            name="Other_Flat_Type__c"
                            type="text"
                            className={`form-control valid select ${props.errorMessage.Other_Flat_Type__c ? 'need-fix' : ''}`}
                            value={props.form.Other_Flat_Type__c || ''}
                            onChange={props.onInputChanged}
                            disabled={props.form.Flat_Type__c !== 'Others'}
                        />
                        <p className="error-message">{props.errorMessage.Other_Flat_Type__c}</p>
                    </div>
                     <div className="form-group">
                        <label>Unit Number/House Number <small className="red">(required)</small></label>
                        <input
                            id="Unit_Number__c"
                            name="Unit_Number__c"
                            type="text"
                            className={`form-control valid select ${props.errorMessage.Unit_Number__c ? 'need-fix' : ''}`}
                            value={props.form.Unit_Number__c || ''}
                            onChange={props.onInputChanged}
                        />
                        <p className="error-message">{props.errorMessage.Unit_Number__c}</p>
                    </div>
                    {/* <div className="form-group">
                        <label>Country <small style={{ color: 'red' }}>(required)</small></label><br />
                        <select
                            className={`form-control valid select ${props.errorMessage.Country__c ? 'need-fix' : ''}`}
                            name="Country__c"
                            onChange={props.onInputChanged}
                            value={props.form.Country__c || 'Singapore'}
                            defaultValue="Singapore"
                        >
                            {countryList.map(country => <option key={shortid.generate()} value={country}>{country}</option>)}
                        </select>
                        <p className="error-message">{props.errorMessage.Country__c}</p>
                    </div> */}
                </div>
            </div>
        );
    }
}

Address.propTypes = {
    form: PropTypes.object.isRequired,
    getPostaCodeOptions: PropTypes.func.isRequired,
    onInputChanged: PropTypes.func.isRequired,
    objectInfo: PropTypes.object.isRequired,
    errorMessage: PropTypes.object.isRequired,
};

export default Address;



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Registration/Tab2/Address.js
// module id = 1011
// module chunks = 0